import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { createResource, useResource } from '@/lib/i18n'
import { NextPage } from 'next'
import Image from 'next/image'
import { eventLogProducer } from '@/lib/event-logger'
import { Action } from '@@/action_pb'
import { getABTestResult, isServer, shimmer, toBase64 } from '@/lib/utils'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import { useCurrentLanguage } from '@/lib/current-language'
import Calculation from './calculation'
import LazyLoad from 'react-lazyload'
import { playPath } from '@/lib/utils'
import { IDownloadType, ILocation } from '@/lib/enums/device'
import IosDownloadBtn from '../common/ios-download-btn'
import { Button, Dialog, DialogContent, DialogTitle, Grid, SvgIcon } from '@material-ui/core'
import { CancelPresentationTwoTone } from '@material-ui/icons'

const resource = createResource({
  en: {
    fiveMinutes: 'Only Need 5 Minutes',
    applyNow: 'Apply now',
    apkText: 'Scan To Download APK',
    mainTitle: 'Get fast online loan, just in 5 minutes on Kredit Pintar',
  },
  id: {
    fiveMinutes: 'CUKUP 5 MENIT',
    applyNow: 'Ajukan sekarang',
    apkText: 'Scan untuk Download APK',
    mainTitle: 'Dapatkan Pinjaman Online Cepat Cair Cukup 5 Menit di Kredit Pintar',
  },
})

type Params = {
  isMobile: boolean
}

const Banner: NextPage<Params> = (params: Params) => {
  const { t } = useResource(resource)
  const { language: lng } = useCurrentLanguage()
  const { width } = useWindowSize()
  const isMobile = width < 1000
  const isFromMobile = width > 0 ? width < 600 : params.isMobile
  const branch = isServer ? 'A' : getABTestResult()
  const [open, setOpen] = useState(false)

  useEffect(() => {
    eventLogProducer.push({
      action: Action.HOMECONTENTLOADRESULT,
      extra: { branch },
    })

    // Trigger setOpen(true) only if the user opens the page for the first time and after visiting another website
    if (typeof window !== 'undefined') {
      const isFirstVisit = !sessionStorage.getItem('hasVisited')
      // const referrer = document.referrer
      // const isFromAnotherWebsite = referrer && !referrer.includes(window.location.hostname)

      if (isFirstVisit /* || isFromAnotherWebsite */) {
        setOpen(true)
        sessionStorage.setItem('hasVisited', 'true')
      }

      // Clear 'hasVisited' when navigating back to the website
      // window.addEventListener('beforeunload', () => {
      //   localStorage.removeItem('hasVisited')
      // })
    }

    // Close the dialog after 1 minute
    if (open) {
      const timer = setTimeout(() => {
        setOpen(false)
      }, 60000) // 1 minute in milliseconds

      return () => clearTimeout(timer) // Cleanup the timer on component unmount
    }
  }, [open])

  const handleClose = () => {
    setOpen(false)
  }

  const goToDown = (herf: string) => {
    eventLogProducer.push({
      action: Action.GETITONAPPGALLERYBUTTONCLICK,
    })
    setTimeout(() => {
      window.open(herf)
    }, 1000)
  }

  const eventClick = () => {
    eventLogProducer.push({
      action: Action.GETITONGOOGLEPLAYBUTTONCLICK,
    })
    goToDown(playPath(IDownloadType.GOOGLE_PLAY, '', ILocation.HOME))
  }
  return (
    <BannerBox showSubTitle={branch === 'A'} innerWidth={width}>
      <div className="container">
        <div className="left">
          <section className="brands">
            <div className="ojk">
              <Image
                src={'/images/home/ojk-logo-new-25.png'}
                width={isFromMobile ? 87 : 174}
                height={isFromMobile ? 24 : 48}
                quality={85}
                priority
                placeholder="blur"
                blurDataURL={`data:image/svg+xml;base64,${toBase64(
                  shimmer(isFromMobile ? 87 : 174, isFromMobile ? 24 : 48),
                )}`}
                alt="ojk"
              />
            </div>
            <div className="afpi">
              <Image
                src={'/images/home/afpi-new.png'}
                width={isFromMobile ? 59 : 118}
                height={isFromMobile ? 24 : 48}
                quality={85}
                priority
                placeholder="blur"
                blurDataURL={`data:image/svg+xml;base64,${toBase64(
                  shimmer(isFromMobile ? 59 : 118, isFromMobile ? 24 : 48),
                )}`}
                alt="afpi"
              />
            </div>
            <div className="brand-logo">
              <Image
                src={'/images/home/top-brand.png'}
                width={isFromMobile ? 24 : 48}
                height={isFromMobile ? 24 : 48}
                quality={85}
                priority
                placeholder="empty"
                alt="brand-logo"
              />
            </div>
            <div className="brand-logo">
              <Image
                src={'/images/home/bsi-iso.png'}
                width={isFromMobile ? 48 : 95}
                height={isFromMobile ? 24 : 48}
                quality={85}
                priority
                placeholder="empty"
                alt="brand-logo"
              />
            </div>
            <div className="brand-logo">
              <Image
                src={'/images/home/laps-sjk-logo.png'}
                width={isFromMobile ? 48 : 95}
                height={isFromMobile ? 24 : 48}
                quality={85}
                priority
                placeholder="empty"
                alt="brand-logo"
              />
            </div>
          </section>
          <h1 className="hide-title">{t('mainTitle')}</h1>
          <div className="subtitle">
            {lng === 'en' ? (
              <span>
                Get
                <p className="line-title"> Fast, Low Interest Loans </p>
                from Kredit Pintar
              </span>
            ) : (
              <span>
                Dapatkan Pencairan
                <p className="line-title"> Pinjaman Dana Cepat </p>
                dengan Bunga Rendah
              </span>
            )}
          </div>
          {branch === 'A' ? (
            <h2 className="des">
              {lng === 'id' ? (
                <span>
                  Pinjam uang cepat hingga
                  <span className="green"> 50 Juta </span>
                  tanpa jaminan
                </span>
              ) : (
                <span>
                  Receive up to
                  <span className="green"> IDR 50,000,000 </span>
                  disbursement
                </span>
              )}
            </h2>
          ) : (
            <div></div>
          )}

          <LazyLoad>
            <div className="google-play">
              <section className="banner goto" onClick={eventClick}>
                <img className="qrcode" src="/images/qrcode/qr_home_gp.png" alt="qrcode" />
                <Image
                  src="/images/home/google_play.png"
                  alt="google_play"
                  width={217}
                  height={66}
                  quality={85}
                  placeholder="blur"
                  blurDataURL={`data:image/svg+xml;base64,${toBase64(shimmer(217, 66))}`}
                />
              </section>
              <div className="self-down">
                <IosDownloadBtn location={ILocation.HOME} isMobile={isMobile} />
              </div>
            </div>
            <div className="google-play">
              <div className="app_gallery" onClick={() => goToDown(playPath(IDownloadType.HUAWEI))}>
                <section className="banner goto">
                  <Image
                    src="/images/home/app_gallery.png"
                    alt="app_play"
                    width={217}
                    height={66}
                    quality={85}
                    placeholder="blur"
                    blurDataURL={`data:image/svg+xml;base64,${toBase64(shimmer(217, 66))}`}
                  />
                </section>
              </div>
              <div className="app_gallery">
                <section className="banner self-down">
                  <img className="qrcode" src="/images/qrcode/qr_apk.png" alt="qrcode" />
                  <span className="apk_text">{t('apkText')}</span>
                  <Image
                    src="/images/qrcode/qr_apk_bg.png"
                    alt="qr_apk_bg"
                    width={217}
                    height={66}
                    quality={85}
                    placeholder="blur"
                    blurDataURL={`data:image/svg+xml;base64,${toBase64(shimmer(217, 66))}`}
                  />
                </section>
              </div>
            </div>
          </LazyLoad>
        </div>
        <div className="right">
          <Calculation />
        </div>
        <Dialog
          open={open}
          keepMounted
          onClose={handleClose}
          PaperProps={{
            style: {
              width: '100%',
              margin: 0,
              maxWidth: '100%',
              position: 'absolute',
              bottom: 0,
              left: 0,
              overflowX: 'hidden',
            },
          }}
        >
          <SvgIcon
            style={{ position: 'absolute', top: 0, right: 0 }}
            component={CancelPresentationTwoTone}
            onClick={handleClose}
          />
          <DialogContent>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={12} md={10}>
                {lng === 'id' ? (
                  <>
                    <p>
                      Waspadai penipuan dan selalu gunakan platform resmi untuk bertransaksi. Pastikan ulang semua
                      informasi yang ada berikut juga pada detail pembayaran.
                    </p>
                    <p>
                      HATI-HATI, TRANSAKSI INI BERISIKO TINGGI. ANDA DAPAT SAJA MENGALAMI KERUGIAN ATAU KEHILANGAN UANG.
                      JANGAN BERUTANG JIKA TIDAK MEMILIKI KEMAMPUAN MEMBAYAR. PERTIMBANGKAN SECARA BIJAK SEBELUM
                      BERTRANSAKSI.
                    </p>
                  </>
                ) : (
                  <>
                    <p>
                      Be cautious of potential scams and always use Kredit Pintar&apos;s official channels for
                      transactions. Verify all information, repayment details, and terms carefully.
                    </p>
                    <p>
                      {' '}
                      PLEASE BE AWARE, THIS TRANSACTION CARRIES A HIGH RISK. YOU MAY EXPERIENCE LOSSES OR LOSE MONEY.
                      DON&apos;T TAKE LOAN IF YOU DON&apos;T HAVE ABILITY TO REPAY. CONSIDER THIS WISELY BEFORE
                      TRANSACTION.
                    </p>
                  </>
                )}
              </Grid>
              <Grid item xs={12} md={2}>
                <Button
                  role="button"
                  aria-disabled="false"
                  style={{
                    marginTop: '10px',
                    width: '100%',
                    height: '40px',
                    lineHeight: '40px',
                    backgroundColor: '#1cc812',
                    color: 'white',
                    textAlign: 'center',
                    borderRadius: '8px',
                  }}
                  onClick={handleClose}
                >
                  {lng === 'id' ? 'Mengerti' : 'Understand'}
                </Button>
              </Grid>
            </Grid>
          </DialogContent>
          {/* <DialogActions>
            <Button onClick={handleClose} color="primary">
              Disagree
            </Button>
            <Button onClick={handleClose} color="primary">
              Agree
            </Button>
          </DialogActions> */}
        </Dialog>
      </div>
    </BannerBox>
  )
}

export default Banner

type IBannerBox = {
  showSubTitle: boolean
  innerWidth: number
}

const BannerBox = styled.div<IBannerBox>`
  .hide-title {
    position: absolute;
    top: 0;
    opacity: 0;
    z-index: -1;
  }
  @media only screen and (max-width: 1000px) {
    .container {
      height: ${(props) =>
        `${
          props.showSubTitle
            ? `${(props.innerWidth * (432 / 320)).toFixed()}px`
            : `${(props.innerWidth * (376 / 320)).toFixed()}px`
        }`};
      background: #eff0f0;
      position: relative;
      margin: 0 auto 110px;
      padding: 0 24px !important;
      img {
        width: 100%;
      }
      .left {
        padding-top: 17px !important;
        width: 100% !important;
        .brands {
          display: flex;
          align-items: center;
          .lazyload-wrapper {
            display: flex;
          }
          .ojk {
            width: 20%;
            margin-right: 20px;
          }
          .afpi {
            width: 20%;
          }
          .brand-logo {
            width: 20%;
            text-align: center;
          }
        }
        .line-title {
          display: inline;
          font-size: 20px;
        }
        .subtitle {
          font-size: 16px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.87);
          line-height: 20px;
        }
        .des {
          width: 240px;
          font-size: 12px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          margin-top: 16px;
          color: #9e9e9e;
          line-height: 16px;
        }
        .green {
          color: #1cc812;
        }
        .google-play {
          display: none;
        }
        .app_gallery {
          display: none;
        }
        .apply-btn {
          position: absolute;
          bottom: -72px;
          left: 50%;
          transform: translateX(-50%);
          width: 208px;
          line-height: 40px;
          height: 40px;
          background: #1cc812;
          border-radius: 8px;
          text-align: center;
          font-size: 14px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: #ffffff;
          z-index: 99;
        }
      }
      .hide-close {
        display: none !important;
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    .container {
      height: 612px;
      width: 100%;
      max-width: 1440px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 0 150px;
      background-image: url('/images/home/banner-b.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin-bottom: 80px;
      img {
        width: 100%;
      }
      .left {
        padding-top: 72px;
        .brands {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 450px;
          .ojk {
            width: auto;
            height: 54px;
          }
          .afpi {
            width: auto;
            height: 54px;
          }
          .brand-logo {
            width: 64px;
          }
        }
        .line-title {
          display: inline;
          font-size: 40px;
          font-family: Roboto-Bold, Roboto;
          font-weight: 500;
        }
        .subtitle {
          font-size: 32px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.87);
          line-height: 36px;
          margin-top: 54px;
        }
        .des {
          width: 520px;
          font-size: 20px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          margin-top: 30px;
          color: #9e9e9e;
          line-height: 28px;
        }
        .green {
          color: #1cc812;
        }
        .app_gallery {
          margin-top: 16px;
          width: 217px;
        }
        .google-play {
          display: flex;
          &:first-child {
            margin-top: 50px;
          }
          .goto {
            cursor: pointer;
          }
          .banner {
            position: relative;
            width: 217px;
            height: 66px;
            box-sizing: border-box;
            .qrcode {
              position: absolute;
              top: 50%;
              right: 0;
              transform: translateY(-50%);
              width: 100%;
              height: 100%;
              z-index: 1;
              opacity: 0;
            }
          }
          .banner:hover .qrcode {
            top: 140px;
            width: 160px;
            height: 160px;
            border-radius: 8px;
            background: #fff;
            box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.1);
            border: 1px solid #f5f5f5;
            opacity: 1;
            z-index: 3;
          }
          .self-down {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 10px;
            .apk_text {
              position: absolute;
              font-size: 16px;
              font-family: Roboto-Medium, Roboto;
              font-weight: 500;
              color: #fff;
              letter-spacing: -0.6px;
              line-height: 19px;
              width: 58%;
              padding-left: 8px;
              z-index: 1;
            }
          }
        }
        .apply-btn {
          display: none;
        }
      }
      .right {
        margin: 6% 0 0 0;
      }
    }
  }
`
